import { Container } from '@acies/core';
import { IconTitleSection } from '@acies/ui';
import AnswersList from './answers-list';
import AnswersListHeader from './answers-list-header';
import ItemConfigurationRenderer from './item-configuration-renderer';

export default class AnswersSection extends IconTitleSection {
	#container!: Container;
	#answersListHeader!: AnswersListHeader;
	#answersList!: AnswersList;
	#itemConfigurationRenderer!: ItemConfigurationRenderer;
	public constructor() {
		super();
		this.width = 'fill';
		this.height = 'fill';
		this.icon = 'clipboard';
		this.text = 'Konfiguration';
	}

	public get container(): Container {
		if (!this.#container) {
			this.#container = new Container();
			this.#container.width = 'fill';
			this.#container.height = 'fill';
			this.#container.autoLayout = 'vertical';
			this.#container.gapVertical = 8;
			// the stock configuration's row between the header and the list, so it stays put while the
			// answers below it scroll, and is dealt again when a pick changes them
			this.#container.addComponents([this.answersListHeader, this.itemConfigurationRenderer, this.answersList]);
		}
		return this.#container;
	}

	/** Where a stock position's item configuration is picked, shown only for a stock configuration with configurations to pick among. */
	public get itemConfigurationRenderer(): ItemConfigurationRenderer {
		if (!this.#itemConfigurationRenderer) {
			this.#itemConfigurationRenderer = new ItemConfigurationRenderer();
		}
		return this.#itemConfigurationRenderer;
	}

	public get answersListHeader(): AnswersListHeader {
		if (!this.#answersListHeader) {
			this.#answersListHeader = new AnswersListHeader();
		}
		return this.#answersListHeader;
	}

	public get answersList(): AnswersList {
		if (!this.#answersList) {
			this.#answersList = new AnswersList();
		}
		return this.#answersList;
	}

	protected override initialize(): void {
		super.initialize();
		this.body.addComponents([this.container]);
	}
}
customElements.define('ac-answers-section', AnswersSection);
